import { createColumnHelper } from '@tanstack/react-table';
import { useEffect } from 'react';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { IAdminxStore } from '../../stores';
import { DomainFactorModel } from '../../models/domain-factor.model';
import { IMergedHeadersReturn } from './index.headers';
import { isSubRow } from '@monorepo/base/src/components/table/table';
import { TableSelectionHeader, TableSelectionCell } from '@monorepo/base/src/components/table/table-selection-cell/table-selection-cell';
import { TableMergeColumn } from '@monorepo/base/src/components/table/table-merge-column/table-merge-column';
import { useDomainFactorsActions } from '../actions/domain-factors.actions';
import { QuickActionsMenu } from '@monorepo/base/src/components/table/quick-actions-menu/quick-actions-menu';

const columnHelper = createColumnHelper<DomainFactorModel>();

export const useDomainFactorsHeaders = (): IMergedHeadersReturn<DomainFactorModel> => {
	const { settingsStore } = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const tableStore = settingsStore.pages.get(currentRouteWithoutSpecialChars)?.tableStore;
	const { EntityActions } = useDomainFactorsActions();

	useEffect(() => {
		if (tableStore && Object.keys(tableStore.getColumnVisibility()).length === 0) {
			tableStore.setDefaultColumnVisibility({
				id: true,
				domain: true,
				campaign_id: true,
				daily_max_loss_factor: true,
			});
			tableStore.setColumnVisibility(tableStore.getDefaultColumnVisibility());
		}
	}, [tableStore]);

	return {
		columns: [
			columnHelper.display({
				id: 'selection',
				enableHiding: false,
				header: headerProps => <TableSelectionHeader headerProps={headerProps} />,
				cell: cellProps => {
					if (isSubRow(cellProps.row)) {
						return <span></span>;
					}
					return (
						<TableMergeColumn>
							<TableSelectionCell cellProps={cellProps} />
							<QuickActionsMenu>
								<EntityActions entity={new DomainFactorModel(cellProps.row.original)} />
							</QuickActionsMenu>
						</TableMergeColumn>
					);
				},
			}),
			columnHelper.accessor('id', {
				header: 'ID',
				enableSorting: false,
				cell: ({ row }) => row.original.getId(),
			}),
			columnHelper.accessor('domain', {
				header: 'Domain',
				enableSorting: false,
				cell: ({ row }) => row.original.getDomain(),
			}),
			columnHelper.accessor('campaign_id', {
				header: 'Campaign ID',
				enableSorting: false,
				cell: ({ row }) => row.original.getCampaignId(),
			}),
			columnHelper.accessor('daily_max_loss_factor', {
				header: 'Daily max loss factor',
				enableSorting: false,
				cell: ({ row }) => row.original.getDailyMaxLossFactor(),
			}),
		],
	};
};
